import { render } from "./ModifyHospital.vue?vue&type=template&id=70bbbe98&scoped=true"
import script from "./ModifyHospital.vue?vue&type=script&lang=js"
export * from "./ModifyHospital.vue?vue&type=script&lang=js"

import "./ModifyHospital.vue?vue&type=style&index=0&id=70bbbe98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70bbbe98"]])

export default __exports__